import http from './ajax';
export default {

  // 添加用户应用
  add(params) {
    return http.post('/api/key/app/add', params);
  },

  // 编辑应用名称
  edit(params) {
    return http.post('/api/key/app/update', params);
  },

  // 获取用户应用列表
  getAppList(params) {
    return http.get('/api/key/app/list', params);
  }

};
